"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  LiveActivities: () => LiveActivities,
  WidgetUI: () => import_view.WidgetUI,
  Widgets: () => Widgets
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var import_view = require("./view");
var Widgets = Object.freeze({
  write(_data) {
    return Promise.resolve();
  },
  writeView(_view) {
    return Promise.resolve();
  }
});
var LiveActivities = Object.freeze({
  start(_title, _state) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject((0, import_nativeError.missingNativeBuild)("LiveActivities.start"));
  },
  startView(_title, _view) {
    var _push = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Promise.reject((0, import_nativeError.missingNativeBuild)("LiveActivities.startView"));
  },
  update(_id, _state) {
    return Promise.resolve();
  },
  updateView(_id, _view) {
    return Promise.resolve();
  },
  end(_id) {
    return Promise.resolve();
  },
  pushToken(_id) {
    return Promise.resolve(null);
  },
  onPushToken(_listener) {
    return function() {
    };
  }
});
//# sourceMappingURL=unavailable.js.map
